import React from "react";
import classes from './FanZone.module.css'
import {FanZoneData} from "../../../api/scheme";
import {useTranslation} from "react-i18next";
import {IZone} from "../../../api/zone";

type FanZoneSVGProps = {
    preferredLanguage?: "ro" | "en" | "ru";
    onFanZoneClick?: (e: React.MouseEvent<SVGTextElement>, fanId?: number) => void;
    fanZones: FanZoneData[];
    zones: IZone[],
    clientScreen?: boolean
};

const FanZone: React.FC<FanZoneSVGProps> = ({
                                                fanZones,
                                                onFanZoneClick,
                                                preferredLanguage,
                                                zones,
                                                clientScreen,
                                            }) => {
    const {
        i18n: {language},
        t,
    } = useTranslation();
    const currentLanguage = preferredLanguage ?? language;

    return (
        <>
            {fanZones.map((fanZone, index) => {
                if (!fanZone || !fanZone.properties) return null;

                const zoneIndex = zones.map((z) => z.id).indexOf(fanZone.zone || -1);
                const fill =
                    zoneIndex !== -1 ? zones[zoneIndex].properties.color : "#a6a6a6";
                const rect = fanZone.properties.rectangle.rect;
                const stylesRectangles = fanZone.properties.rectangle.styles ?? {};
                const textStyles = fanZone.properties.text.styles ?? {};
                const textTranslations = fanZone.properties.text.translations ?? {};
                const textToDisplay =
                    textTranslations[currentLanguage as keyof typeof textTranslations] ||
                    fanZone.name;

                const width = parseFloat(stylesRectangles.width || "100");
                const height = parseFloat(stylesRectangles.height || "50");
                const fontSize = textStyles.fontSize || 12;

                return (
                    <g key={index} transform={`translate(${rect.x}, ${rect.y})`}>
                        <rect
                            data-type="fan-fanZone"
                            id={"fz-" + index}
                            onClick={(e) => onFanZoneClick!(e as any, fanZone.id)}
                            width={width}
                            height={height}
                            fill={fill || stylesRectangles.fill || "#e0e0e0"}
                            className={classes.fanZoneContainer}
                        />
                        <text
                            data-type="fan-fanZone"
                            x={width / 2}
                            y={height / 2 - fontSize}
                            fontSize={fontSize}
                            fill={textStyles.fill || "#000"}
                            textAnchor="middle"
                            dominantBaseline="middle"
                            style={{
                                userSelect: "none",
                            }}
                        >
                            {textToDisplay}
                        </text>
                        {!clientScreen && (
                            <text
                                data-type="fan-fanZone"
                                x={width / 2}
                                y={(height / 2 - fontSize) + fontSize}
                                fontSize={fontSize - 2}
                                fill={textStyles.fill || "#000"}
                                textAnchor="middle"
                                dominantBaseline="middle"
                                style={{
                                    userSelect: "none",
                                }}
                            >
                                {t(`priceEditor.total`)} {t(`priceEditor.seats`)}:{" "}
                                {fanZone.max_seats}
                            </text>
                        )}
                        {!clientScreen && (
                            <text
                                data-type="fan-fanZone"
                                x={width / 2}
                                y={(height / 2 - fontSize) + (fontSize * 2)}
                                fontSize={fontSize - 2}
                                fill={textStyles.fill || "#000"}
                                textAnchor="middle"
                                dominantBaseline="middle"
                                style={{
                                    userSelect: "none",
                                }}>
                                {t(`priceEditor.seatsLeft`)}: {fanZone.free_seats}
                            </text>
                        )}
                    </g>
                );
            })}
        </>
    );
};

export default React.memo(FanZone);
